// extracted by mini-css-extract-plugin
export default {"errorBanner":"subscription-plans_errorBanner__8QMFD"};